var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTwitterOval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30.0 30.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1554 L0,1554 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8932743,0 C23.1186026,0 29.7865487,6.66794605 29.7865487,14.8932743 C29.7865487,23.1186026 23.1186026,29.7865487 14.8932743,29.7865487 C6.66794605,29.7865487 0,23.1186026 0,14.8932743 C0,6.66794605 6.66794605,0 14.8932743,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0127434,0 C13.0372566,0 13.9624779,0.432212389 14.6118584,1.12380531 C15.4223894,0.964247788 16.1846018,0.668230088 16.8724779,0.260176991 C16.6061947,1.0919469 16.0420354,1.78884956 15.3069027,2.22929204 C16.0269027,2.14380531 16.7134513,1.95238938 17.3516814,1.66938053 C16.8746018,2.38327434 16.2711504,3.0100885 15.5750442,3.51185841 C15.5819469,3.66424779 15.5853982,3.8179646 15.5853982,3.97221239 C15.5853982,8.67690265 12.0045133,14.1013274 5.45654867,14.1013274 C3.44628319,14.1013274 1.57460177,13.5122124 0,12.5017699 C0.277964602,12.5349558 0.562035398,12.5516814 0.848761062,12.5516814 C2.51707965,12.5516814 4.05185841,11.9827434 5.27044248,11.0277876 C3.71230088,10.9988496 2.39787611,9.96955752 1.94495575,8.55557522 C2.16212389,8.59699115 2.38486726,8.61902655 2.61477876,8.61902655 C2.93893805,8.61902655 3.2540708,8.57575221 3.55247788,8.4939823 C1.92424779,8.16716814 0.696637168,6.72849558 0.696637168,5.00362832 L0.696902655,4.95849558 C1.17663717,5.22584071 1.7259292,5.3859292 2.30920354,5.40424779 C1.35451327,4.7660177 0.725575221,3.6759292 0.725575221,2.44115044 C0.725575221,1.78884956 0.901327434,1.17690265 1.20769912,0.651238938 C2.96362832,2.80566372 5.58690265,4.22283186 8.54548673,4.37123894 C8.48442478,4.11053097 8.45283186,3.83893805 8.45283186,3.5599115 C8.45283186,1.59424779 10.0470796,0 12.0127434,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-413.0 -471.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.0 200.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0 60.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 26.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 135.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.0 50.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.00026548672566306664 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 29.7865487,0 29.7865487,29.7865487 0,29.7865487 0,0",
    stroke: "none",
    fill: "#55ACEE"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.664513274336281 9.03398230088496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17.3516814,0 17.3516814,14.1013274 0,14.1013274 0,0",
    stroke: "none",
    fill: "#F1F2F2"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitterOval);
export default __webpack_public_path__ + "static/media/icTwitterOval.7d524cf478244bd8a8ed184cb9693208.svg";
export { ForwardRef as ReactComponent };